import { HorizontalRule as HorizontalRuleToExtend } from '@tiptap/extension-horizontal-rule';

export const HorizontalRule = HorizontalRuleToExtend.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                default: null
            },
            style: {
                default: null
            }
        }
    }
})
